import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router';
import axiosUmbraco from '../axios/axiosUmbraco';
const BaseURL = process.env.REACT_APP_BACKEND_API;

export default function SinglePost({ toast }) {
    const location = useLocation();
    const [singlePostItem, setSinglePostItem] = useState({});
    const searchParams = new URLSearchParams(location.search);
    const pageId = searchParams.has("id")
        ? searchParams.get("id")
        : false;

    async function getPostDetails() {
        try {
            const res = await axiosUmbraco.get(`/umbraco/delivery/api/v2/content/item/${pageId}`);
            const formattedData = {
                title: res?.data?.properties?.newsTitle ?? '',
                description: res?.data?.properties?.newsDescription?.markup ?? '',
                image: res?.data?.properties?.newsImage?.length > 0 ? res?.data?.properties?.newsImage[0].url : '',
            }
            setSinglePostItem(formattedData)
        } catch (error) {
            console.error('error in getting seasons', error)
        }
    }

    useEffect(() => {
        getPostDetails();
    }, [])

    return (
        <div className='row pt-3'>
            <h2 className='roboto-custom-black col-sm-8 col-12 fw-bold' >{singlePostItem?.title}</h2>
            {singlePostItem?.image &&
                <div className='col-12' >
                    <img src={`${BaseURL}${singlePostItem?.image}`} className='w-100' />
                </div>
            }
            <div className=' col-12' dangerouslySetInnerHTML={{ __html: singlePostItem?.description }} ></div>

        </div>
    )
}
